import { BaseAPI } from "./BaseAPI";
import axios from "axios";

export class ApplicationAPI extends BaseAPI {


  //查詢違法繳費詳情
  async getDetails({ illegalYear, autoNo, docNo, captcha }) {
    console.log("違法繳費參數", illegalYear, autoNo, docNo, captcha);

    return axios
      .post(`${this._getContext()}/public/application/query/details`, null, {
        params: {
          illegalYear,
          autoNo,
          docNo,
          captcha,
        },
      })
      .then((res) => res.data);
  }
  async getSignDetails({ illegalYear, autoNo, docNo, expire, signature }) {

    return axios
      .post(`${this._getContext()}/public/application/sign/query/details`, null, {
        params: {
          illegalYear,
          autoNo,
          docNo,
          expire,
          signature
        },
      })
      .then((res) => res.data);
  }
  async checkedPaymentResult(transactionNo) {
    return axios
      .get(`${this._getContext()}/gov_pay/${transactionNo}/query`)
      .then((res) => res.data);
  }

  //下載pdf
  async downloadPDF({ illegalYear, autoNo, docNo, expire, signature }) {
    return axios.get(`${this._getContext()}/public/application/download/pdf`, {
      responseType: "blob",
      params: {
        illegalYear,
        autoNo,
        docNo,
        expire,
        signature
      },
    });
  }

  //下載收據
  async downloadReceipts({ illegalYear, autoNo, docNo, expire, signature }) {
    return axios.get(`${this._getContext()}/public/application/download/pay/receipts`, {
      responseType: "blob",
      params: {
        illegalYear,
        autoNo,
        docNo,
        expire,
        signature
      },
    });
  }

  /**一戶通的接口 */
  //查詢違法繳費列表
  async getGovList({
    status,
    docType,
    docNo,
    autoNo,
    illegalYear,
  }) {
    return axios
      .post(`${this._getContext()}/mo/application/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}/query/list`, {
        status,
        docType,
        docNo,
        autoNo,
        illegalYear,
      })
      .then((res) => res.data);
  }


  //查詢違法繳費詳情
  async getGovDetails({ illegalYear, autoNo, docNo, captcha }) {
    return axios
      .post(`${this._getContext()}/mo/application/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}/query/details`, null, {
        params: {
          illegalYear,
          autoNo,
          docNo,
          captcha,
        },
      })
      .then((res) => res.data);
  }

  async getIdentityNo() {
    return axios
      .get(`${this._getContext()}/mo/application/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}/personal-information`)
      .then((res) => res.data);
  }

  async getGovSignDetails({ illegalYear, autoNo, docNo, expire, signature }) {
    return axios
      .post(`${this._getContext()}/mo/application/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}/sign/query/details`, null, {
        params: {
          illegalYear,
          autoNo,
          docNo,
          expire,
          signature
        },
      })
      .then((res) => res.data);
  }

  async getSignature({ illegalYear, autoNo, docNo }) {
    return axios
      .get(`${this._getContext()}/mo/gov_pay/signature/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}`, {
        params: {
          illegalYear, autoNo, docNo
        }
      })
      .then((res) => res.data);
  }

  async downloadGovPDF({ illegalYear, autoNo, docNo, expire, signature }) {
    return axios.get(`${this._getContext()}/mo/application/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}/download/pdf`, {
      responseType: "blob",
      params: {
        illegalYear,
        autoNo,
        docNo,
        expire,
        signature
      },
    });
  }

  async downloadGovReceipts(applicationNo) {
    return axios.get(`${this._getContext()}/mo/application/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}/download/pay/receipts`, {
      responseType: "blob",
      params: {
        applicationNo
      },
    });
  }

  downloadGovReceiptsByUrl() {
    return this.getFullUrl(`${this._getContext()}/mo/application/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}/download/pay/receipts`, {})
  }

  downloadGovPDFByUrl(params) {
    return this.getFullUrl(`${this._getContext()}/mo/application/${process.env.VUE_APP_API_IS_APP}/${process.env.VUE_APP_API_TYPE}/download/pdf`, params)
  }


  getFullUrl(path, params = {}) {
    const origin = window.location.origin;
    const sanitizedPath = path.startsWith('/') ? path : `/${path}`;
    const url = new URL(sanitizedPath, origin); // 自动拼接 origin 和路径
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.append(key, String(value)); // 转为字符串并编码
      }
    });
    return url.toString();
  }

}

export default new ApplicationAPI();
